export default function getNativeTokenIconUrl(symbol: string | undefined, image?: string | null) {
  return symbol === 'DOTO' ? '/assets/doto-native.jpg' : image || undefined;
}
